module.exports = __webpack_public_path__ + "static/media/jewelry-earrings-white.5cca874d.svg";